import { reusableOrders } from 'data/mock-data';

const mock = () => ({
  data: { reusableOrders },
});

export default mock;
